var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18185 15.0243H13.1191C13.4913 15.0243 13.7998 14.7127 13.7998 14.3368C13.7998 13.961 13.4913 13.6585 13.1191 13.6585H8.18185C7.80974 13.6585 7.50116 13.961 7.50116 14.3368C7.50116 14.7127 7.80974 15.0243 8.18185 15.0243ZM11.2495 9.07516H8.18185C7.80974 9.07516 7.50116 9.38683 7.50116 9.76266C7.50116 10.1385 7.80974 10.441 8.18185 10.441H11.2495C11.6216 10.441 11.9302 10.1385 11.9302 9.76266C11.9302 9.38683 11.6216 9.07516 11.2495 9.07516ZM17.7265 8.27364C17.9398 8.27118 18.1721 8.2685 18.3832 8.2685C18.6101 8.2685 18.7916 8.45183 18.7916 8.681V16.051C18.7916 18.3243 16.9673 20.1668 14.7165 20.1668H7.49208C5.13234 20.1668 3.20825 18.2327 3.20825 15.8493V5.96766C3.20825 3.69433 5.04158 1.8335 7.30149 1.8335H12.148C12.384 1.8335 12.5655 2.026 12.5655 2.25516V5.20683C12.5655 6.88433 13.936 8.25933 15.5969 8.2685C15.9848 8.2685 16.3268 8.2714 16.6261 8.27393C16.859 8.27591 17.066 8.27766 17.2487 8.27766C17.3779 8.27766 17.5453 8.27573 17.7265 8.27364ZM17.9768 6.93566C17.2307 6.93841 16.3513 6.93566 15.7187 6.92925C14.7149 6.92925 13.8881 6.09416 13.8881 5.08033V2.664C13.8881 2.26891 14.3627 2.07275 14.6341 2.35783C15.1257 2.87406 15.8013 3.58382 16.4737 4.29018C17.1434 4.99362 17.8098 5.6937 18.2881 6.19591C18.5531 6.47366 18.3588 6.93475 17.9768 6.93566Z",
    fill: "#0B1A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.e3447205082ac0c4879f14d70ec02743.svg";
export { ForwardRef as ReactComponent };